import React, { useState, useEffect } from "react";
import { v4 as uuid } from 'uuid'
import { Product } from "./assortmentPlanningProductTable";

export default function PreOrderForm(props: any) {
  const [productNumber, setProductNumber] = useState('');
  const [option1, setOption1] = useState('');
  const [currentProduct, setCurrentProduct] = useState<Product>();
  const [collection, setCollection] = useState(0);
  const [period, setPeriod] = useState(0);
  const [response, setResponse] = useState('');
  const [quantity, setQuantity] = useState(50);
  const [error, setError] = useState('');

  const createPreOrder = async () => {
    await createPreOrderPost();
    setResponse("did it");
  }

  const onCreatedPreOrder = () => {
    props.onCreatedPreOrder();
  }

  const onQuantityChange = (event: any) => {
    setQuantity(event.target.value)
  }

  const createPreOrderPost = async () => {
    if (period > 0) {
      try {
        const response = await fetch('https://dev-rms2.cleverapps.se/api/assortmentplanning/preorders', {
          method: 'POST',
          headers: {
            "X-Cleverapps-Tenant": "int2",
            "Authorization": "2cb6f1fbde9548fe86a75d86a77ba43d",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ExternalOrderNumber: uuid(),
            ProductNumber: currentProduct?.productNumber,
            Option1: currentProduct?.option1,
            Quantity: quantity,
            Collection: collection,
            Period: period
          })
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        onCreatedPreOrder();
        setError('');
      } catch (err: any) {
        setError(err.message);
      }
    }
  }

  useEffect(() => {
    setCurrentProduct(props.currentProduct);
    setQuantity(props.currentProduct?.totalPlannedQuantity);
    setPeriod(props.period);
    setCollection(props.collection);
  }, [props.products, props.period, props.currentProduct])

  return (
    <div>
      <p>Period: {period}, Product: {currentProduct?.productNumber}, Collection: {collection}, Option1: {currentProduct?.option1}</p>
      <p>Response: {response}</p>
      <p>Error: {error}</p>
      <input type="text" value={quantity} onChange={onQuantityChange} />
      <button onClick={createPreOrder}>Set Quantity</button>
    </div>
  );
}